import { render, staticRenderFns } from "./documentUpload.vue?vue&type=template&id=0bd6bd02&"
import script from "./documentUpload.vue?vue&type=script&lang=ts&"
export * from "./documentUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports